import { loadSession } from './authApi';
import { getSyncConfig } from './syncConfig';
import type { ShareTemplate } from './shareTemplates';
export type ShareTemplateStore = { revision: number; templates: ShareTemplate[] };
export async function requestShareTemplates(body?: {expectedRevision: number; templates: ShareTemplate[]}): Promise<ShareTemplateStore> {
  const controller = new AbortController();
  const timer = setTimeout(() => controller.abort(), 20000);
  try {
    const response = await fetch((getSyncConfig()?.serverUrl || window.location.origin).replace(/\/+$/, '') + '/api/share-templates', {
      method: body ? 'POST' : 'GET', cache: 'no-store', signal: controller.signal,
      headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${loadSession()?.token || ''}` },
      body: body ? JSON.stringify(body) : undefined,
    });
    const data = await response.json();
    if (!response.ok) throw Error(data.error || '读取或保存分享模板失败，请重试');
    if (!Number.isSafeInteger(data.revision) || !Array.isArray(data.templates)) throw Error('服务器模板响应无效，请重试');
    return data;
  } catch (e) {
    if (e instanceof TypeError || (e instanceof Error && e.name === 'AbortError')) throw Error('无法连接服务器读取或保存分享模板，请重试');
    throw e;
  } finally { clearTimeout(timer); }
}
